module.exports = __webpack_public_path__ + "img/logow.d653f4fc.png";